import { useCallback, useContext, useMemo } from 'react';
import _get from 'lodash/get';

import { AuthContext } from 'context/AuthContext';
import { findEcommPlatform } from 'utils/extra/DICTIONARY';

/**
 * @typedef {'SHOPIFY' | 'WOOCOMMERCE' | 'BIGCOMMERCE'} EcommPlatformSource
 */

/**
 * @typedef {Object} EcommPlatformInfo E-commerce platfrom information of the loggein user's store
 * @property {EcommPlatformSource} ecommPlatformSource E-commerce platform source
 * @property {String} ecommPlatformName E-commerce platform name in human readable format
 * @property {String} ecommPlatformPlanName E-commerce platform plan name
 * @property {(platform: EcommPlatformSource) => boolean} checkIfPlatformIs Check if the e-commerce platform is the provided platform
 */

/**
 * @returns {EcommPlatformInfo} ecommPlatform information
 */
export default function useEcomPlatform() {
  const { storeProperties } = useContext(AuthContext);

  const ecommPlatform = _get(storeProperties, 'ecommerce_platform', null);
  const ecommPlatformSource = _get(ecommPlatform, 'source', '');
  const ecommPlatformPlanName = _get(ecommPlatform, 'plan_name', '');

  const ecommPlatformName = useMemo(() => {
    if (!ecommPlatformSource) return '';
    return findEcommPlatform(ecommPlatformSource);
  }, [ecommPlatformSource]);

  const checkIfPlatformIs = useCallback(
    platform => ecommPlatformSource === platform,
    [ecommPlatformSource]
  );

  return {
    ecommPlatformName,
    ecommPlatformSource,
    ecommPlatformPlanName,
    checkIfPlatformIs
  };
}
